import { PRIVACY_URL } from "../lib/constants";

export const Footer = () => (
  <footer className="pt-10 pb-2 text-center" data-testid="app-footer">
    <p className="text-[11px] uppercase tracking-[0.3em] text-ink/35">Leggera Flow</p>
    <p className="mx-auto mt-2 max-w-xs text-[11px] leading-relaxed text-ink/45" data-testid="privacy-statement">
      Il test non salva le tue risposte. Alla fine puoi iscriverti con la tua email per ricevere il risultato: in quel caso i dati sono gestiti da Brevo, come spiegato nell'informativa.{" "}
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-privacy-link"
        className="underline underline-offset-2 transition-colors hover:text-coral"
      >
        Informativa sulla privacy
      </a>
    </p>
  </footer>
);
